export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT = "LOGOUT";
export const LOADING = "LOADING";
export const CHECK_LOGIN = "CHECK_LOGIN";

export const CREATE_ACCOUNT_SUCCESS = "CREATE_ACCOUNT_SUCCESS";
export const CREATE_ACCOUNT_ERROR = "CREATE_ACCOUNT_ERROR";

export const CHANGE_PASS_SUCCESS = "CHANGE_PASS_SUCCESS";
export const CHANGE_PASS_ERROR = "CHANGE_PASS_ERROR";

export const FETCH_GROUPS = "FETCH_GROUPS";
export const FETCH_CATEGORIES = "FETCH_CATEGORIES";
export const FETCH_SUBCATEGORIES = "FETCH_SUBCATEGORIES";
export const FETCH_PROFESSIONALS = "FETCH_PROFESSIONALS";

export const GET_USER = "GET_USER";
export const UPDATE_ACCOUNT_SUCCESS = "UPDATE_ACCOUNT_SUCCESS";

export const CLEAN_UPDATE_MSG = "CLEAN_UPDATE_MSG";
export const SET_UPDATE_ERROR = "SET_UPDATE_ERROR";
export const SET_UPDATE_LOADING = "SET_UPDATE_LOADING";

export const SET_CATEGORY = "SET_CATEGORY";
export const SET_PROFESSIONAL = "SET_PROFESSIONAL";

export const RECOVER_PASSWORD_SUCCESS = "RECOVER_PASSWORD_SUCCESS";
export const RECOVER_PASSWORD_FAILED = "RECOVER_PASSWORD_FAILED";
export const CLEAN_RECOVER_STATE = "CLEAN_RECOVER_STATE";

export const ADD_CONSULT_REQUEST_ANSWER = "ADD_CONSULT_REQUEST_ANSWER";
export const REMOVE_CONSULT_REQUEST_ANSWER = "REMOVE_CONSULT_REQUEST_ANSWER";

export const FETCH_CHATS = "FETCH_CHATS";
export const UPDATE_CHATS_WITH_CONTACT_DATA = "UPDATE_CHATS_WITH_CONTACT_DATA";
export const UPDATE_CHAT_WITH_MESSAGES = "UPDATE_CHAT_WITH_MESSAGES";
export const UPDATE_CHAT_LAST_MESSAGE = "UPDATE_CHAT_LAST_MESSAGE";
export const UPDATE_CHAT_DATA = "UPDATE_CHAT_DATA";
export const FETCH_VIDEO_NOTIFICATIONS = "FETCH_VIDEO_NOTIFICATIONS";
export const REMOVE_VIDEO_NOTIFICATION = "REMOVE_VIDEO_NOTIFICATION";
export const ADD_CHAT_NOTIFICATION = "ADD_CHAT_NOTIFICATION";
export const CLEAN_CHAT_NOTIFICATIONS = "CLEAN_CHAT_NOTIFICATIONS";
export const UPDATE_CHAT_LIST = "UPDATE_CHAT_LIST";
export const UPDATE_CONSULT_STATUS = "UPDATE_CONSULT_STATUS";
